import styled from "styled-components";
import Variables from "../../../../assets/styleVariables";

const LINE_WIDTH = 120
export const StepsContainer = styled.div`
  box-sizing: border-box;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  padding: 28px 0 16px;
`;


export const Bollet = styled.div`
  position: relative;
  width: 12px;
  height: 12px;
  background-color: ${props => {
    if (props.active) {
      return Variables.colors.primary_700;
    } else if (props.visited) {
      return Variables.colors.primary_500;
    } else {
      return Variables.colors.complementary_400;
    }
  }};
  border-radius: 50%;
  margin-left: ${LINE_WIDTH}px;
  &:after {
    display: block;
    content: ' ';
    background-color: ${props => {
      if (props.active) {
        return Variables.colors.complementary_400;
      } else if (props.visited) {
        return Variables.colors.primary_500;
      } else {
        return Variables.colors.complementary_400;
      }
    }};
    height: 2px;
    width: ${LINE_WIDTH}px;
    position: absolute;
    top: calc(50% - 1px);
    right: 12px;
  }
  &:first-child {
    ${props => {
      if (props.active) {
        return `
          &:after {
            background-color: ${Variables.colors.complementary_400};
          }
        `;
      }  
    }};
  }
  &:last-child {
    margin-left: 0;
    &:after {
      display: none;
    }
  }
  span {
    position: absolute;
    top: -23px;
    right: calc(-50% - 18px);
    width: 90px;
    text-align: right;
    font-size: ${Variables.font_sizes.x_medium};
    color: ${props => props.active ? Variables.colors.complementary_800 : Variables.colors.complementary_400};
  }
`;